import * as styles from './IconCircle.modules.css';

export default (color, children, onClick, id, aclass = '') => {
  return (
    <div class={`${styles.iconCircle} ${aclass}`} id>
      {children}
    </div>
  );
};
